import { createMuiTheme } from "@material-ui/core/styles";
import {
    colorWhite,
    colorBlack,
    colorPrimary,
    colorSecondary,
    colorError,
    colorInputBorder,
    colorTextAdditional, colorSecondary_2, colorInputBorderGrayish, colorBorder,
} from "./Constants/theme";
import {store, RootState} from "./redux/store";
import {useSelector, useDispatch} from "react-redux";
import {ThemeProvider} from "@material-ui/core/styles";
import React, {useEffect} from "react";
import { LightenDarkenColor } from "lighten-darken-color";
import API from "./helpers/apiHelpers";
import WebFont from "webfontloader";
// import {setBranding} from "./redux/branding/branding.actions";

// eslint-disable-next-line react/prop-types
const ReduxThemeProvider = ({ children }) => {
    const dispatch = useDispatch();
    const branding = useSelector((state: RootState) => state?.branding);
    const preferencesOn = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const linkColor = preferencesOn ? branding.brandText : colorPrimary;
    const theme = createMuiTheme({
        palette: {
            common: {
                white: colorWhite,
                black: colorBlack,
            },
            primary: {
                main: preferencesOn? branding.brandHeader : colorPrimary,
            },
            secondary: {
                main: preferencesOn? branding.brandAccent : colorSecondary,
            },
            error: {
                main: colorError,
            },
            text: {
                primary: preferencesOn? branding.brandHeader : colorPrimary,
                secondary: preferencesOn? branding.brandText : colorInputBorder
            }
        },
        typography: {
            allVariants: {
                fontFamily: preferencesOn? branding.textFont : "Inter",
                lineHeight: "26px",
                color: preferencesOn? branding.brandText : colorPrimary,
            },
            h2: {
                fontFamily: preferencesOn? branding.headerFont : "Inter",
                fontSize: 28,
                fontWeight: "bold",
                lineHeight: "35px",
                color: preferencesOn? branding.brandHeader : colorPrimary,
            },
            h3: {
                fontWeight: "bold",
                fontSize: 24,
                color: preferencesOn? branding.brandHeader : colorPrimary,
            },
            h4: {
                fontWeight: "bold",
                fontSize: 20,
                color: preferencesOn? branding.brandHeader : colorPrimary,
            },
            body2: {
                fontSize: 16,
                fontWeight: 700,
            },
            button: {
                fontWeight: "bold",
                fontSize: 16,
                textTransform: "none",
                color: preferencesOn? branding.brandHeader : colorPrimary,
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    height: 48,
                    color: colorPrimary,
                    "&$disabled": {
                        backgroundColor: colorInputBorderGrayish + " !important",
                        border: "1.5px solid " + colorInputBorder,
                        borderRadius: "6px",
                    },
                },
                containedPrimary: {
                    color: preferencesOn ? branding.brandHeader : colorPrimary,
                    backgroundColor: colorWhite,
                    border: "1.5px solid " + (preferencesOn ? branding.brandHeader : colorPrimary),
                    borderRadius: "6px",
                    boxShadow: "none",
                    "& svg": {
                        color: "inherit",
                    },
                    "&:hover": {
                        color: colorWhite,
                        backgroundColor: preferencesOn ? branding.brandAccent : colorSecondary,
                        borderColor: preferencesOn ? branding.brandAccent : colorSecondary,
                        boxShadow: "none",
                    },
                },
                containedSecondary: {
                    border: preferencesOn? branding.brandAccent : colorSecondary,
                    color: preferencesOn? branding.buttonText : colorPrimary,
                    "&:hover": {
                        color: colorWhite,
                    },
                },
                contained: {
                    backgroundColor: colorWhite,
                    color: colorInputBorder,
                    border: "1.5px solid " + colorInputBorder,
                    borderRadius: "6px",
                    boxShadow: "none"
                }
            },
            MuiInput: {
                root: {
                    borderWidth: 1
                },
            },
            MuiIconButton: {
                root: {
                    padding: 0,
                },
            },
            MuiInputAdornment: {
                positionEnd: {
                    marginLeft: 8,
                },
            },
            MuiOutlinedInput: {
                root: {
                    "&$disabled": {
                        color: preferencesOn? branding.brandText : colorInputBorder,
                    },
                },
                notchedOutline: {
                    borderColor: colorInputBorder,
                },
                adornedEnd: {
                    display: "flex",
                    flexDirection: "row-reverse",
                    paddingLeft: "14px",
                    paddingRight: 0,
                },
            },
            MuiSelect: {
                root: {
                    width: 241,
                    height: 48
                }
            },
            MuiFormControlLabel: {
                label: {
                    "&$disabled": {
                        color: preferencesOn? branding.brandText : colorInputBorder,
                    }
                }
            },
            MuiPaper: {
                root: {
                    backgroundColor: colorWhite,
                },
            },
            MuiCard: {
                root: {
                    backgroundColor: colorWhite,
                }
            },
            MuiLink: {
                root: {
                    color: linkColor,
                    textDecoration: "underline",
                    textDecorationColor: linkColor,
                    "&:hover": {
                        color: linkColor,
                        textDecoration: "underline",
                        textDecorationColor: linkColor,
                    },
                },
            },
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 765,
                lg: 1280,
                xl: 1920,
            },
        }
    });

    useEffect(() => {
        if(preferencesOn) {
            WebFont.load({
                google: {
                    families: [branding.headerFont, branding.textFont]
                }
            });
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default ReduxThemeProvider;
